var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown"},[_vm._v(" "+_vm._s(_vm.arr[3])+"时"+_vm._s(_vm.arr[4])+"分 ")])}
var staticRenderFns = []

export { render, staticRenderFns }